import { render } from "./CIS-Home-Icon-Content-Item.vue?vue&type=template&id=72fe2639&scoped=true"
import script from "./CIS-Home-Icon-Content-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Icon-Content-Item.vue?vue&type=script&lang=js"

import "./CIS-Home-Icon-Content-Item.vue?vue&type=style&index=0&id=72fe2639&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fe2639"]])

export default __exports__